
  import StarRating from '@/mixins/StarRating';
  export default {
    name: 'StarRatingActionButton',
    mixins: [StarRating],
  };
